export const IconGraySalaryWallet20: {
  name: 'icon_gray_salary_wallet_20-cb791b16fd94'
} = {
  name: 'icon_gray_salary_wallet_20-cb791b16fd94'
}
